import { Controller, useFormContext } from 'react-hook-form';
import { Box, Chip, InputLabel, TagsSearchDropdown } from '@hopskipdrive/react-components';

import { useTags } from '../../../hooks/useTags';

import { TagsContentListTitle } from './RideTags.style';

export const RideTags = () => {
  const { control } = useFormContext();
  const { tags, debouncedQueryTags } = useTags();

  return (
    <>
      <TagsContentListTitle>
        <InputLabel>Tags</InputLabel>
      </TagsContentListTitle>
      <Box ml="10%" flexGrow={1}>
        <Controller
          control={control}
          name="tagList"
          defaultValue={''}
          render={({ field: { onChange, value } }) => (
            <TagsSearchDropdown
              options={tags.map((tag) => ({ label: tag }))}
              placeholder="Select tags or add new ones"
              handleUpdatedTags={(updatedTagsList) => onChange(updatedTagsList?.map((tag) => tag.label).join(','))}
              values={value
                ?.split(',')
                .filter((tag) => tag)
                .map((tag) => ({
                  label: tag,
                }))}
              handleQuery={(e) => debouncedQueryTags(e.target.value)}
            />
          )}
        />
      </Box>
    </>
  );
};

export const ViewRideTags = ({ tags }: { tags: string[] }) => (
  <>
    <TagsContentListTitle>
      <InputLabel>Tags</InputLabel>
    </TagsContentListTitle>
    <Box ml="10%" flexGrow={1} display="flex" gap="0.5rem" flexWrap="wrap">
      {tags.map((tag) => (
        <Chip key={tag} label={tag} />
      ))}
    </Box>
  </>
);
